@if (geoGeschaeft) {
  <cap-content-header>
    <cap-title>
      <span
        >{{ "titel.detail.geometergeschaeft" | translate }}:
        <cap-kompakt-geometergeschaeft [item]="geoGeschaeft.geometergeschaeft"> </cap-kompakt-geometergeschaeft>
        <span>{{ geoGeschaeft.beschreibung ? ", " + geoGeschaeft.beschreibung : "" }}</span>
      </span>
    </cap-title>
  </cap-content-header>
}

@if (geoGeschaeft) {
  <div class="mt-2 detail-form">
    <ul [activeId]="'geschaeftDetails'" #nav="ngbNav" class="nav-tabs" ngbNav>
      <li [ngbNavItem]="'geschaeftDetails'">
        <a ngbNavLink>{{ "Geschaeftdetails" | translate }}</a>
        <ng-template id="tabGeschaeftDetail" ngbNavContent>
          <div id="details">
            <div class="row mt-md-2">
              <div class="col-md-6 col-sm-12">
                <cap-kopfdatenelement label="Gemeinde">
                  @if (polGemeinde) {
                    <span> {{ polGemeinde.bfsNummer }} {{ polGemeinde.name }} </span>
                  }
                </cap-kopfdatenelement>
                <cap-kopfdatenelement label="Nummer">
                  <cap-kompakt-geometergeschaeft [item]="geoGeschaeft.geometergeschaeft"></cap-kompakt-geometergeschaeft>
                </cap-kopfdatenelement>
                <cap-kopfdatenelement [value]="geoGeschaeft.kopfdatenDetailEntry?.geschaeftsTyp | translate" label="Typ">
                </cap-kopfdatenelement>
                <cap-kopfdatenelement [value]="geoGeschaeft.status | translate" label="Geschäftsstatus"></cap-kopfdatenelement>
                <cap-kopfdatenelement
                  [value]="geoGeschaeft.kopfdatenDetailEntry?.projektMutationTyp | translate"
                  label="Mutationsart"></cap-kopfdatenelement>
                @if (geoGeschaeft.kopfdatenDetailEntry?.mVerarbeitungArt.access !== "DEACTIVATED") {
                  <cap-kopfdatenelement [value]="geoGeschaeft.kopfdatenDetailEntry?.verarbeitungArt | translate" label="Verarbeitungsart">
                  </cap-kopfdatenelement>
                }
                @if (geoGeschaeft.mAvMutation.access !== "DEACTIVATED") {
                  <cap-kopfdatenelement label="AV-Mutationsnummer">
                    <cap-kompakt-av-mutation [item]="geoGeschaeft.avMutation"></cap-kompakt-av-mutation>
                  </cap-kopfdatenelement>
                }
              </div>
              <div class="col-md-6 col-sm-12">
                <cap-kopfdatenelement [value]="geoGeschaeft.auftragsDatum | datum" label="Auftragsdatum"></cap-kopfdatenelement>
                <cap-kopfdatenelement [value]="geoGeschaeft.bereitGBDatum | datumZeit" label="BereitFuerGrundbuch"></cap-kopfdatenelement>
                <cap-kopfdatenelement
                  [value]="geoGeschaeft.datumRueckmeldungGB | datum"
                  label="RueckmeldungGrundbuch"></cap-kopfdatenelement>
                <cap-kopfdatenelement [value]="geoGeschaeft.abschlussDatum | datum" label="Abschlussdatum"></cap-kopfdatenelement>
                @if (geoGeschaeft.kopfdatenDetailEntry?.mAuftraggeberFreitext.access !== "DEACTIVATED") {
                  <cap-kopfdatenelement [value]="geoGeschaeft.kopfdatenDetailEntry?.auftraggeberFreitext" label="AuftraggeberFreitext">
                  </cap-kopfdatenelement>
                }
                @if (geoGeschaeft.kopfdatenDetailEntry?.mAktenempfaengerFreitext.access !== "DEACTIVATED") {
                  <cap-kopfdatenelement
                    [value]="geoGeschaeft.kopfdatenDetailEntry?.aktenempfaengerFreitext"
                    label="AktenempfaengerFreitext">
                  </cap-kopfdatenelement>
                }
                @if (geoGeschaeft.mVermarkungZurueckgestellt.access !== "DEACTIVATED") {
                  @if (geoGeschaeft.vermarkungZurueckgestellt) {
                    <cap-kopfdatenelement [value]="'Ja' | translate" label="Geometergeschaeft.detail.VermarkungZurueckgestellt">
                    </cap-kopfdatenelement>
                  }
                  @if (!geoGeschaeft.vermarkungZurueckgestellt) {
                    <cap-kopfdatenelement [value]="'Nein' | translate" label="Geometergeschaeft.detail.VermarkungZurueckgestellt">
                    </cap-kopfdatenelement>
                  }
                }
              </div>
              <div class="col-md-12 col-sm-12">
                <cap-kopfdatenelement [bodyClass]="'col-md-10 col-sm-10'" [labelClass]="'col-md-2 col-sm-2'" label="Beschreibung">
                  @if (geoGeschaeft.mBeschreibung.access === "NONE") {
                    <div class="mb-2">
                      <span>{{ "gemaessGrundbuch" | translate }}</span>
                    </div>
                  } @else {
                    {{ geoGeschaeft.beschreibung }}
                  }
                  <ng-template #beschreibung>
                    {{ geoGeschaeft.beschreibung }}
                  </ng-template>
                </cap-kopfdatenelement>
                @if (geoGeschaeft.kopfdatenDetailEntry?.mAuftraggeber.access !== "DEACTIVATED") {
                  <cap-stammperson-table [stammpersonenListLoader]="auftraggeber" [tableFullWidth]="false" [title]="'auftraggeber'">
                  </cap-stammperson-table>
                }
                @if (geoGeschaeft.kopfdatenDetailEntry?.mAktenempfaenger.access !== "DEACTIVATED") {
                  <cap-stammperson-table [stammpersonenListLoader]="aktenempfaenger" [tableFullWidth]="false" [title]="'aktenempfaenger'">
                  </cap-stammperson-table>
                }
                <cap-beschreibung-table-wrapper [tableFullWidth]="false" class="my-2">
                  <span class="cap-table-wrapper-title">
                    <h3 class="mt-md-2 mb-md-2">{{ "Grundbuchgeschaeft" | translate }}</h3>
                  </span>
                  <ng-container class="cap-table-wrapper-content">
                    <cap-list-loader [listLoader]="listLoaderGbGeschaeft" [showTotal]="false" [showZeilenSelect]="false">
                      <div class="cap-list-loader-content">
                        <table class="cap-table-detail">
                          <thead>
                            <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
                          </thead>
                          <tbody>
                            <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
                          </tbody>
                        </table>
                      </div>
                    </cap-list-loader>
                  </ng-container>
                </cap-beschreibung-table-wrapper>
                <ng-template #tableHeaders>
                  <tr>
                    <th>{{ "Tagebuchnummer" | translate }}</th>
                    <th>{{ "Status" | translate }}</th>
                    <th>{{ "Eingang" | translate }}</th>
                    <th>{{ "Anmelder" | translate }}</th>
                    <th>{{ "Beschreibung" | translate }}</th>
                  </tr>
                </ng-template>
                <ng-template #tableRows>
                  @for (grundbuchgeschaeft of listLoaderGbGeschaeft?.items; track grundbuchgeschaeft) {
                    <tr>
                      <td>
                        <cap-kompakt-grundbuchgeschaeft [item]="grundbuchgeschaeft"></cap-kompakt-grundbuchgeschaeft>
                      </td>
                      <td>
                        <cap-link
                          [enableNavigation]="grundbuchgeschaeft.timePoint.isNavigierbar"
                          [params]="[grundbuchgeschaeft?.id.id]"
                          [target]="navTargets.NAV_GRUNDBUCHGESCHAEFT">
                          {{ grundbuchgeschaeft?.status | translate }}
                        </cap-link>
                      </td>
                      <td>
                        <cap-link
                          [enableNavigation]="grundbuchgeschaeft.timePoint.isNavigierbar"
                          [params]="[grundbuchgeschaeft?.id.id]"
                          [target]="navTargets.NAV_GRUNDBUCHGESCHAEFT">
                          {{ grundbuchgeschaeft?.eingangTagebuch | datum }}
                        </cap-link>
                      </td>
                      <td>
                        <cap-link
                          [enableNavigation]="grundbuchgeschaeft.timePoint.isNavigierbar"
                          [params]="[grundbuchgeschaeft?.id.id]"
                          [target]="navTargets.NAV_GRUNDBUCHGESCHAEFT">
                          @for (anmelder of grundbuchgeschaeftAnmelder; track anmelder; let i = $index) {
                            <cap-kompakt-stammperson
                              [auskunftsperre]="anmelder.auskunftsperre"
                              [item]="anmelder.version"
                              format="STAMMPERSON_TYP02">
                            </cap-kompakt-stammperson>
                            @if (i < grundbuchgeschaeftAnmelder.length - 1) {
                              <span>,<br /></span>
                            }
                          }
                        </cap-link>
                      </td>
                      <td>
                        @if (grundbuchgeschaeft?.mBeschreibung.access !== "NONE") {
                          <span>
                            <cap-link
                              [enableNavigation]="grundbuchgeschaeft.timePoint.isNavigierbar"
                              [params]="[grundbuchgeschaeft?.id.id]"
                              [target]="navTargets.NAV_GRUNDBUCHGESCHAEFT">
                              {{ grundbuchgeschaeft?.beschreibung }}
                            </cap-link>
                          </span>
                        }
                        @if (grundbuchgeschaeft?.mBeschreibung.access === "NONE") {
                          <span> {{ "gemaessGrundbuch" | translate }}</span>
                        }
                      </td>
                    </tr>
                  }
                </ng-template>
              </div>
            </div>
          </div>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
    <cap-content-header>
      <cap-title name="title">
        <h3>{{ "BeteiligteGrundstuecke" | translate }}</h3>
      </cap-title>
      <cap-title-functionbar>
        @if (grundstueckIds.length >= 2) {
          <button
            (click)="getZip()"
            [disabled]="gbPrintService.zipInProgressMap.get(0)"
            class="btn btn-outline-primary btn-sm me-2"
            type="button">
            @if (gbPrintService.zipInProgressMap.get(0)) {
              <span class="spinner-border spinner-border-sm text-primary me-1"></span>
            }
            {{ "Auszüge" | translate }} {{ "(" + grundstueckIds.length + ")" }}
          </button>
        }
      </cap-title-functionbar>
    </cap-content-header>
    <cap-grundstueck-table
      (grundstueckIdsListEventItem)="updateCheckedGrundstueckIdList($event)"
      [listLoader]="beteiligteGrundstueckeLoader"
      [showZeilenSelect]="false">
    </cap-grundstueck-table>
  </div>
} @else {
  <cap-breadcrumb></cap-breadcrumb>
  <cap-spinner-small></cap-spinner-small>
}
